export const SURFACE_PRESSURE_BAR = 1.0;
export const MSW_PER_BAR = 10.0;
export const BAR_PER_MSW = 0.1;

export const ALVEOLAR_WATER_VAPOR_BAR = 0.0627;

export function depthToAmbient(depthMsw: number): number {
  return SURFACE_PRESSURE_BAR + depthMsw * BAR_PER_MSW;
}

export function ambientToDepth(ambientBar: number): number {
  return (ambientBar - SURFACE_PRESSURE_BAR) * MSW_PER_BAR;
}

export function alveolarPressure(depthMsw: number): number {
  return Math.max(0, depthToAmbient(depthMsw) - ALVEOLAR_WATER_VAPOR_BAR);
}
